import { ViteSSG } from "vite-ssg"; // runtime
import { createPinia } from "pinia";
import App from "./App.vue";
import { routes, attachRouterGuards, scrollBehavior } from "./routes";
import i18n from "@/i18n";
import { useMetaDataStore } from "@/datastore/module/metaData.js";
import "./styles/index.css";
import "swiper/css";

export const createApp = ViteSSG(
  App,
  { routes: routes, base: import.meta.env.BASE_URL, scrollBehavior },
  async ({ app, router, initialState, onSSRAppRendered }) => {
    const pinia = createPinia();
    app.use(pinia);
    const metaStore = useMetaDataStore();
    if (import.meta.env.SSR) {
      metaStore.setLocale("en");
      onSSRAppRendered(() => {
        initialState.pinia = pinia.state.value;
      });
    } else {
      if (initialState.pinia) {
        pinia.state.value = initialState.pinia || {};
      }
      const ScriptX = await import("vue-scriptx");
      const Ads = await import("vue-google-adsense");
      const { VueMasonryPlugin } = await import("vue-masonry");
      const { loadPlugins } = await import("@/Plugins/loadPlugins");

      app.use(ScriptX);
      app.use(Ads.Adsense);
      app.use(VueMasonryPlugin);
      loadPlugins();
    }
    app.use(i18n);
    attachRouterGuards(router);
  },
);
